import Fav from '../modules/Fav';
import Rating from '../modules/Rating';
import {event} from '../modules/event';

class ClubMap {
	constructor(wrapper) {
		this._declare(wrapper);
		this._createMap();
		this._createPlacemarkAll();
        this._addEvents();
	}

	_declare(wrapper){
        this.wrapper = wrapper;
		this.data = JSON.parse(wrapper.getAttribute('data-param'));
		this.myMap;
        this.baseUrl = (window.location + '').indexOf('/build/') === -1 ? '/static/' : '';
        this.oPlacemarkAll = {};
	}

	_createMap(){
		this.myMap = new ymaps.Map(this.wrapper, {
			center: [this.data.lat, this.data.lon],
			zoom: this.data.zoom,
			controls: ["zoomControl"],
			behaviors: ['default', 'scrollZoom']
		}, {
			searchControlProvider: 'yandex#search'
		});
		this.myMap.behaviors.disable(['scrollZoom']);
	}

	_createPlacemarkAll(){
        var parent = this,
            placemarkAll = parent.data.placemarkAll,
            Placemark = class {
                constructor(data) {
                    this.data = data;
                    this.isFav = this.data.isFav;
                    this.balloonLayout = this._createBalloonLayout();
                    this.balloonContentLayout = this._createBalloonContentLayout();
                    this.placemark = this._createPlacemark();
                }

                _getPlacemarkData(){
                    var placemarkData = {};
                    if(this.isFav){
                        placemarkData.href = parent.baseUrl + 'img/symbols/map-icon-fav.png';
                        placemarkData.size = [45, 48];
                        placemarkData.imageOffset = [-17, -48];
                        placemarkData.balloonOffset = [-21, 19];
                    }
                    else {
                        placemarkData.href = parent.baseUrl + 'img/symbols/map-icon.png';
                        placemarkData.size = [16, 16];
                        placemarkData.imageOffset = [-8, -8];
                        placemarkData.balloonOffset = [-21, 19];
                    }
                    return placemarkData;
                }

                _createBalloonLayout(){
                    var self = this,
                        MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="layer layer-reverse  balloon">' +
                            '<a data-js="close" class="balloon_close" href="#">' +
                                '<svg class="symbol symbol-x symbol-balloon" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' +
                           '</a>' +
                            '<div class="balloon_wrapper">'+
                                '$[[options.contentLayout observeSize maxWidth=380]]'+
                            '</div>'+
                        '</div>', {
                            build: function () {
                                var selfParam = this;

                                this.constructor.superclass.build.call(this);

                                this._$element = $('.balloon', this.getParentElement()) ;


                                var closeBtn = this._$element[0].querySelector('[data-js="close"]');
                                event.add(closeBtn, 'click', function(e){selfParam.onCloseClick.call(selfParam, e)});

                                self._buildBalloonContent.call(self, this._$element.find('.balloon_inner')[0]);

                                this.applyElementOffset();
                            },
                            clear: function () {
                                this.constructor.superclass.clear.call(this);
                                if(self.favBalloon) self.favBalloon.del();
                                self.ratingBalloon.del();
                            },
                            onSublayoutSizeChange: function () {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                                if(!this._isElement(this._$element)) {
                                    return;
                                }

                                this.applyElementOffset();

                                this.events.fire('shapechange');
                            },
                            applyElementOffset: function () {
                                this._$element.css({
                                    left: 0,
                                    top: -(this._$element[0].offsetHeight) - 40
                                });
                            },
                            onCloseClick: function (e) {
                                e.preventDefault();
                                this.events.fire('userclose');
                            },
                            getShape: function () {
                                if(!this._isElement(this._$element)) {
                                    return MyBalloonLayout.superclass.getShape.call(this);
                                }

                                var position = this._$element.position();

                                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                    [position.left, position.top], [
                                        position.left + this._$element[0].offsetWidth,
                                        position.top + this._$element[0].offsetHeight
                                    ]
                                ]));
                            },
                            _isElement: function (element) {
                                return element && element[0];
                            }
                        }
                    );
                    return MyBalloonLayout;
                }

                _buildBalloonContent(wrapper){
                    wrapper.innerHTML = this._createBalloonHtml();

                    var box = wrapper.firstChild;

                    if(this.isFav !== undefined) this.favBalloon = this._addFav(box);
                    this.ratingBalloon = this._addRating(box);
                }

                _createBalloonContentLayout(){
                    var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="balloon_inner">' +
                            '$[properties.content]' +
                        '</div>'
                    );
                    return MyBalloonContentLayout;
                }
                _createPlacemark(){
                    var data = this._getPlacemarkData(),
                        myPlacemark = new ymaps.Placemark([this.data.lat, this.data.lon], {}, {
                            iconLayout: 'default#image',
                            iconImageHref: data.href,
                            iconImageSize: data.size,
                            iconImageOffset: data.imageOffset,
                            balloonShadow: false,
                            balloonLayout: this.balloonLayout,
                            balloonContentLayout: this.balloonContentLayout,
                            balloonPanelMaxMapArea: 0,
                            hideIconOnBalloonOpen: true,
                            balloonOffset: data.balloonOffset
                        });

                    parent.myMap.geoObjects.add(myPlacemark);
                    return myPlacemark;
                }

                _createBalloonHtml(){
                    var self = this,
                        favClass = function(){
                            if (self.isFav === undefined) return '';
                            if (self.isFav === false) return 'fav fav-club';
                            return 'fav fav-club js-fav';
                        }(),
                        ratingClass = this.data.ratingAllow ? 'js-allowVote' : '',
                        ratingWidth = this.data.rating*10,
                        balloonContent = '<div data-param=\'{"uid":"'+ this.data.uid +'", "type":"'+ this.data.type +'"}\' class="clubBalloon '+ favClass +'">'+
                                            '<a class="link link-default" href="'+ this.data.link +'"><span class="link_border">'+ this.data.name +'</span></a>'+
                                            '<div class="clubBalloon_desc color-desc">'+ this.data.desc +'</div>'+
                                            '<div class="clubBalloon_footer">' +
                                                '<div class="clubBalloon_footer_cell">' +
                                                    '<div data-js="rating-box" class="rating '+ ratingClass +' rating-mini">'+
                                                        '<span class="rating_vote">'+
                                                            '<span data-js="stars" class="rating_stars" style="width:'+ ratingWidth +'%;"></span >'+
                                                            '<a data-star="1" class="rating_star rating_star-1" href="#"></a>'+
                                                            '<a data-star="2" class="rating_star rating_star-2" href="#"></a>'+
                                                            '<a data-star="3" class="rating_star rating_star-3" href="#"></a>'+
                                                            '<a data-star="4" class="rating_star rating_star-4" href="#"></a>'+
                                                            '<a data-star="5" class="rating_star rating_star-5" href="#"></a>'+
                                                            '<a data-star="6" class="rating_star rating_star-6" href="#"></a>'+
                                                            '<a data-star="7" class="rating_star rating_star-7" href="#"></a>'+
                                                            '<a data-star="8" class="rating_star rating_star-8" href="#"></a>'+
                                                            '<a data-star="9" class="rating_star rating_star-9" href="#"></a>'+
                                                            '<a data-star="10" class="rating_star rating_star-10" href="#"></a>'+
                                                        '</span>'+
                                                    '</div>'+
                                                '</div>' +
                                                '<div class="clubBalloon_footer_cell">' +
                                                    '<a data-js="fav-btn" class="fav_btn" href="#">'+
                                                        '<svg class="fav_symbol symbol symbol-health" role="img"><use xlink:href="'+ parent.baseUrl +'img/symbols/sprite.svg#health"></use></svg>'+
                                                    '</a> '+
                                                    '<a class="btn btn-active btn-view4 btn-view4-club" href="'+this.data.linkAfisha+'">Афиша</a>'+
                                                '</div>' +
                                            '</div>' +
                                        '</div>';
                    return balloonContent;
                }

                _addFav(wrapper){
                    var self = this,
                        obj = new Fav(wrapper),
                        data;

                    obj.onchange = function(isFav){
                        if(self.isFav === isFav) return;
                        self.isFav = isFav;
                        self.changeView.call(self);
                    }
                    return obj;
                }

                changeView(){
                    data = this._getPlacemarkData();
                    this.placemark.options.set('iconImageHref', data.href);
                    this.placemark.options.set('iconImageSize', data.size);
                    this.placemark.options.set('iconImageOffset', data.imageOffset);
                    this.placemark.options.set('balloonOffset', data.balloonOffset);
                }

                _addRating(wrapper){
                    var self = this,
                        obj = new Rating(wrapper),
                        data;

                    obj.onchange = function(rating){
                        if(!self.data.ratingAllow) return;

                        self.data.ratingAllow = false;
                        self.data.rating = rating;
                        //self.theater.setAttribute('data-param', JSON.stringify(self.data));
                    }
                    return obj;
                }
            };

		for(var i=0,j=placemarkAll.length; i<j; i++){
            var data = placemarkAll[i];
            this.oPlacemarkAll[data.uid] = new Placemark(data);
		}
	}

    _addEvents(){
        var self = this;
        document.addEventListener("cinemaChangeFav", function(event) {
            var placeMark = self.oPlacemarkAll[event.uid];
            if(placeMark && placeMark.isFav !== event.isFav){
                placeMark.isFav = event.isFav;
                placeMark.changeView.call(placeMark);
            }
        }, false);
    }
}

export {ClubMap};



































